import { useContext } from 'react';
import { FarmContext } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';

export function useSelectedFarm() {
    const { farm } = useContext(FarmContext);
    return farm;
}
